import { Control, ControlType } from './control';

export const EmailRegExp = new RegExp(
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export class EmailControl extends Control<string> {
  constructor(name: string, placeholder: string) {
    super(name, placeholder, ControlType.email, '');
  }

  isValid(): boolean {
    return this.required ? EmailRegExp.test(this.value as string) : true;
  }
}
